import styled from 'styled-components';
import { titleMedium } from 'styles-js/mixins/typography';
export const Container = styled.form`
  margin: 70px 15px;

  @media (${props => props.theme.overScreenXsmall}) {
    max-width: 390px;
    margin: 50px auto;
    padding: 30px;
    border: ${({
  theme
}) => theme.greyLine};
  }

  input {
    width: 100%;
  }
`;
export const Title = styled.h1`
  ${titleMedium};
`;
export const Label = styled.label`
  color: ${({
  theme
}) => theme.colorGreyDark};
`;
export const StyledError = styled.p`
  margin: 5px 0 10px;
  color: ${({
  theme
}) => theme.colorError};
`;